var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6875 5.3125V2.5H3.4375V17.5H14.6875V14.707H15.9375V17.5482C15.9375 17.9661 15.894 18.1176 15.8123 18.2704C15.7306 18.4232 15.6107 18.5431 15.4579 18.6248C15.3051 18.7065 15.1536 18.75 14.7357 18.75H3.38932C2.97142 18.75 2.81988 18.7065 2.6671 18.6248C2.51433 18.5431 2.39442 18.4232 2.31272 18.2704C2.23101 18.1176 2.1875 17.9661 2.1875 17.5482V2.45182C2.1875 2.03392 2.23101 1.88238 2.31272 1.7296C2.39442 1.57683 2.51433 1.45692 2.6671 1.37522C2.81988 1.29351 2.97142 1.25 3.38932 1.25H14.7357C15.1536 1.25 15.3051 1.29351 15.4579 1.37522C15.6107 1.45692 15.7306 1.57683 15.8123 1.7296C15.894 1.88238 15.9375 2.03392 15.9375 2.45182V5.3125H14.6875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4325 9.2953L14.2937 8.15652C14.0229 7.88569 14.0229 7.4466 14.2937 7.17577C14.5646 6.90495 15.0037 6.90495 15.2745 7.17577L17.586 9.48724C17.5955 9.49578 17.6049 9.50464 17.614 9.5138C17.8848 9.78462 17.8848 10.2237 17.614 10.4945L15.2802 12.8283C15.0094 13.0992 14.5703 13.0992 14.2995 12.8283C14.0286 12.5575 14.0286 12.1184 14.2995 11.8476L15.4455 10.7015L10.0198 10.7015C9.63147 10.7015 9.31667 10.3867 9.31667 9.99842C9.31667 9.6101 9.63147 9.2953 10.0198 9.2953L15.4325 9.2953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/SignOut.18b76673.svg";
export { ForwardRef as ReactComponent };